import { Routes } from '@angular/router';

const title = 'Solicitudes de edición';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'pendiente',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Pendientes' }] },
        loadComponent: () => import('./pages/mascota-update-lista/mascota-update-lista.component'),
      },
    
    ],
  },

   {
    path: 'aprobados',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Aprobados' }] },
        loadComponent: () => import('./pages/mascota-update-aprobado-lista/mascota-update-aprobado-lista.component'),
      },
    ],
  },

  {
    path: 'observados',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Observados' }] },
        loadComponent: () => import('./pages/mascota-update-observado-lista/mascota-update-observado-lista.component'),
      },
    ],
  },
];
